import { SearchProps } from 'antd/lib/input';
import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { Input } from '../../components';

interface Props extends SearchProps {
  name: string;
  label?: ReactNode;
}
export default function InputField({ name, ...bag }: Props) {
  return (
    <Field name={name}>
      {({ field, form: { errors } }: FieldProps) => (
        <div>
          <Input.Search error={getIn(errors, name)} {...field} {...bag} />
        </div>
      )}
    </Field>
  );
}
